// @flow
import type { Props } from './types';

import * as React from 'react';
import {
    ButtonContainer,
    CloseButton,
    CloseButtonContainer,
    Description,
    DevicesColumn,
    ListContainer,
    LowerContainer,
    MobileLine,
    ModalContent,
    ModalTitle,
    NonMobileLine,
    ThisActionUses,
    Title,
    UpperContainer
} from './styles';

import { Button, HrefButton, Modal } from '~/components/widgets';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import messages from '../intl';
import DescriptionItem from './description-item/component';

type State = {
    showNano1Modal: boolean,
    showHubRequiredModal: boolean
};
export default class TemplateDescription extends React.Component<Props, State> {
    state = {
        showNano1Modal: false,
        showHubRequiredModal: false
    };

    chooseTemplate = () => {
        const { chooseTemplate, isNano1Incompatible } = this.props;
        isNano1Incompatible ? this.setState({ showNano1Modal: true }) : chooseTemplate();
    };
    hideModal = () => this.setState({ showNano1Modal: false });

    showHubRequiredModal = () => this.setState({ showHubRequiredModal: true });

    hideHubRequiredModal = () => this.setState({ showHubRequiredModal: false });

    render() {
        const {
            _while,
            close,
            description,
            findOutMoreUrl,
            hasHub,
            hiveActionsUrl,
            name,
            templateAvailable,
            then,
            when
        } = this.props;
        const { showNano1Modal, showHubRequiredModal } = this.state;
        return (
            <div>
                <UpperContainer>
                    <CloseButtonContainer onClick={close}>
                        <CloseButton type={generalIcons.CLOSE} />
                    </CloseButtonContainer>
                    <Title>{name}</Title>
                    <ButtonContainer>
                        <MobileLine />
                        {templateAvailable ? (
                            <Button onClick={hasHub ? this.chooseTemplate : this.showHubRequiredModal}>
                                <FormattedMessage {...messages.continue} />
                            </Button>
                        ) : (
                            <HrefButton alternate href={findOutMoreUrl} target="_blank">
                                <FormattedMessage {...messages.findOutMore} />
                            </HrefButton>
                        )}
                    </ButtonContainer>
                </UpperContainer>
                <NonMobileLine />
                <LowerContainer>
                    <Description>{description}</Description>
                    <DevicesColumn>
                        <ThisActionUses>
                            <FormattedMessage {...messages.thisActionUses} />
                        </ThisActionUses>
                        <ListContainer>
                            {when.map((templateEvent, index) => (
                                <DescriptionItem
                                    definition={templateEvent.definition}
                                    hiveLive={templateEvent.hiveLive}
                                    isRequired
                                    key={`when-${index}`}
                                    missingDevice={templateEvent.missingDevice}
                                />
                            ))}
                            {[..._while, ...then].map((templateEvent, index) => (
                                <DescriptionItem
                                    definition={templateEvent.definition}
                                    hiveLive={templateEvent.hiveLive}
                                    key={`while-then-${index}`}
                                    missingDevice={templateEvent.missingDevice}
                                />
                            ))}
                        </ListContainer>
                    </DevicesColumn>
                </LowerContainer>
                <Modal
                    closeText={messages.done}
                    isOpen={showNano1Modal}
                    key="confirm-modal"
                    onRequestClose={this.hideModal}
                >
                    <ModalTitle>
                        <FormattedMessage {...messages.upgradeHubTitle} />
                    </ModalTitle>
                    <ModalContent>
                        <FormattedMessage {...messages.upgradeHubContent} />
                    </ModalContent>
                </Modal>
                <Modal
                    isOpen={showHubRequiredModal}
                    key="hub-required-modal"
                    linkUrl={hiveActionsUrl}
                    onRequestClose={this.hideHubRequiredModal}
                >
                    <ModalTitle>
                        <FormattedMessage {...messages.hubRequiredTitle} />
                    </ModalTitle>
                    <ModalContent>
                        <FormattedMessage {...messages.hubRequiredDescription} />
                    </ModalContent>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template-description/component.js